<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf="usuario && usuario.sucesso" class="container-fluid" [ngClass]="usuario.retorno.aparencia">
    <div style="margin-top: 20px;">
        <ul class="breadcrumb">
            <li><strong>Onde estou:</strong></li>
            <li>
                <span id="lblSubMenu">Cadastro de <b>SubFrotas</b></span>
            </li>
            <li class="active">
                <span *ngIf="!isUpdate" id="lblSubMenu">Incluir</span>
                <span *ngIf="isUpdate" id="lblSubMenu">Alterar</span>
            </li>
        </ul>
        <aside [ngClass]="usuario.retorno.aparencia">
            <form (ngSubmit)="onSubmit(f)" name="subFrota" #f="ngForm">
                <div class="panel panel-default form-filtrar form-default form-group required">
                    <div *ngIf="usuario.retorno.tipo != tipoEntidades.frota && !isUpdate" class="panel panel-info">
                        <div class="panel-heading">
                            <h3 class="panel-title">Frota</h3>
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-12 form-group">
                                    <app-filtro-frota (onFrotaSelected)="selecionaFrota($event)"></app-filtro-frota>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="subFrota.codigoFrota">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h3 class="panel-title">Dados da Sub-Frota</h3>
                            </div>
                            <div class="panel-body">
                                <div *ngIf="usuario.retorno.tipo === 2 || isUpdate" class="row">
                                    <div class="col-md-2 form-group">
                                        <label class='center-block'>
                                            Cód. da Frota
                                        </label>
                                        <input type="text" class="form-control" name="codigoFrota" value=""
                                            [(ngModel)]="subFrota.codigoFrota" [disabled]="true">
                                    </div>
                                    <div class="col-md-4 form-group">
                                        <label class='center-block'>
                                            Fantasia da Frota
                                        </label>
                                        <input type="text" class="form-control" name="nomeReduzidoFrota" value=""
                                            [(ngModel)]="subFrota.nomeReduzidoFrota" [disabled]="true">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class='control-label'>
                                            Descrição / Fantasia Sub-Frota
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="descricao" value=""
                                                style="text-transform: uppercase" [(ngModel)]="subFrota.descricao"
                                                required maxlength="50" #descricao="ngModel">
                                            <div [hidden]="descricao.valid || (descricao.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Descrição inválida !</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="isUpdate" class="col-md-3 form-group">
                                        <label class="control-label">
                                            Combustível (Validação)
                                        </label>
                                        <div class="input-group">
                                            <mat-select name="codigoValidacaoCombustivel"
                                                class="form-control dropdown-filtro" required
                                                [(ngModel)]="subFrota.codigoValidacaoCombustivel"
                                                #codigoValidacaoCombustivel="ngModel">
                                                <mat-option value="1">Sim</mat-option>
                                                <mat-option value="2">Não</mat-option>
                                                <mat-option value="3">Padrão da Frota</mat-option>
                                            </mat-select>
                                            <div [hidden]="codigoValidacaoCombustivel.valid || (codigoValidacaoCombustivel.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Selecione !</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h3 class="panel-title">Dados / Centro de Custo</h3>
                            </div>
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class='center-block'>
                                            Centro de Custo
                                        </label>
                                        <mat-radio-group value="" aria-label="Selectione uma opção"
                                            name="flagCentroCusto" [(ngModel)]="subFrota.flagCentroCusto"
                                            (ngModelChange)="onChangeCentroCusto($event)"
                                            matTooltip="SubFrota será de Centro de Custo / Faturamento ?"
                                            [disabled]="subFrota.flagPadrao === 'S'">
                                            <mat-radio-button value="S" class="radio-filtro">SIM</mat-radio-button>
                                            <mat-radio-button value="N" class="radio-filtro">NÃO</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                    <div *ngIf="subFrota.flagPadrao=== 'S'" class="col-md-3 form-group">
                                        <label class='center-block' style="color: #7d0c12 !important;">
                                            Sub-Frota Padrão (Informações de Faturamento no cadastro da Frota)
                                        </label>
                                    </div>
                                </div>
                                <div *ngIf="subFrota.flagCentroCusto === 'N'" class="row">
                                    <div class="col-md-6 form-group">
                                        <label class='control-label'>
                                            Sub-Frota
                                        </label>
                                        <div class="input-group">
                                            <mat-select [(ngModel)]="subFrota.subFrotaCentroCusto"
                                                name="subFrotaCentroCusto" class="form-control dropdown-filtro"
                                                matTooltip="Selecione a SubFrota de Faturamento" required
                                                #subFrotaCentroCusto="ngModel">
                                                <mat-option *ngFor="let subfrota of subFrotasFaturamento"
                                                    [value]="subfrota.codigo">
                                                    {{subfrota.descricao}}
                                                </mat-option>
                                            </mat-select>
                                            <div [hidden]="subFrotaCentroCusto.valid || (subFrotaCentroCusto.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Selecione a Sub-Frota de Faturamento !</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="subFrota.flagPadrao === 'N'">
                                    <div *ngIf="subFrota.flagCentroCusto === 'S'" class="row">
                                        <div class="col-md-6 form-group">
                                            <label class="control-label">
                                                CNPJ
                                            </label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" name="cnpj" value=""
                                                    [(ngModel)]="subFrota.cnpj" [textMask]="{mask: cnpjmask}"
                                                    appCnpjValidator required #cnpj="ngModel">
                                                <div [hidden]="cnpj.valid || (cnpj.pristine && !f.submitted)"
                                                    style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                    <span>CNPJ inválido !</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class='center-block'>
                                                Email NF-e
                                            </label>
                                            <div class="input-group">
                                                <input type="email" class="form-control"
                                                    style="text-transform: uppercase" name="emailNfe" value=""
                                                    [(ngModel)]="subFrota.emailNfe" maxlength="100" email
                                                    #emailNfe="ngModel">
                                                <div [hidden]="emailNfe.valid || (emailNfe.pristine && !f.submitted)"
                                                    style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                    <span>Email inválido !</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="subFrota.flagCentroCusto === 'S'" class="row">
                                        <div class="col-md-6 form-group">
                                            <label class="control-label">
                                                Inscrição Estadual
                                            </label>
                                            <div class="input-group">
                                                <input type="text" class="form-control"
                                                    style="text-transform: uppercase" name="inscr" value=""
                                                    [(ngModel)]="subFrota.inscr" required
                                                    style="text-transform: uppercase" maxlength="18" #ie="ngModel">
                                                <div [hidden]="ie.valid || (ie.pristine && !f.submitted)"
                                                    style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                    <span>Preencha a inscrição estadual !</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group">
                                            <label class="control-label">
                                                UF
                                            </label>
                                            <div class="input-group">
                                                <mat-select name="iest" class="form-control dropdown-filtro"
                                                    [(ngModel)]="subFrota.iest" required #iest="ngModel">
                                                    <mat-option *ngFor="let uf of ufs" [value]="uf.sigla">{{uf.sigla}}
                                                    </mat-option>
                                                </mat-select>
                                                <div [hidden]="iest.valid || (iest.pristine && !f.submitted)"
                                                    style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                    <span>Selecione a UF !</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group">
                                            <label class='control-label'>
                                                Nota Fiscal aos Cuidados de
                                            </label>
                                            <div class="input-group">
                                                <mat-select name="codigoContato" class="form-control dropdown-filtro"
                                                    matTooltip="Contato para a entrega da NFe"
                                                    [(ngModel)]="subFrota.codigoContato" required #contato="ngModel">
                                                    <mat-option *ngFor="let contato of frotaContatos"
                                                        [value]="contato.codigo">
                                                        {{contato.contato}}
                                                    </mat-option>
                                                </mat-select>
                                                <div [hidden]="contato.valid || (contato.pristine && !f.submitted)"
                                                    style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                    <span>Selecione o contato !</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="subFrota.flagCentroCusto === 'S' || isUpdate" class="panel panel-info">
                            <div class="panel-heading">
                                <h3 class="panel-title">Endereço de Envio da Nota Fiscal</h3>
                            </div>
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-md-3 form-group">
                                        <label
                                            [ngClass]="!isUpdate || subFrota.flagCentroCusto === 'S' ? 'control-label' : 'center-block'">
                                            CEP
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="cepent" value=""
                                                [textMask]="{mask: cepmask}" pattern="[0-9]{5}-?[0-9]{3}"
                                                [required]="!isUpdate || subFrota.flagCentroCusto === 'S'"
                                                #cepEnv="ngModel" [(ngModel)]="subFrota.enderecos[1].cep"
                                                (ngModelChange)="onChangeCep($event, subFrota.enderecos[1], 'ENV')"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                            <div [hidden]="cepEnv.disabled || cepEnv.valid || (cepEnv.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>CEP inválido !</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label
                                            [ngClass]="!isUpdate || subFrota.flagCentroCusto === 'S' ? 'control-label' : 'center-block'">
                                            Logradouro
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" style="text-transform: uppercase"
                                                name="logradouroEnt" value=""
                                                [(ngModel)]="subFrota.enderecos[1].endereco"
                                                style="text-transform: uppercase" maxlength="40"
                                                [required]="!isUpdate || subFrota.flagCentroCusto === 'S'"
                                                #logradouroEnv="ngModel"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                            <div [hidden]="logradouroEnv.disabled || logradouroEnv.valid || (logradouroEnv.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Preencha o Logradouro !</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label class="center-block">
                                            Número
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="numeroEnt" value=""
                                                [(ngModel)]="subFrota.enderecos[1].numero" pattern="^[0-9]\d*$"
                                                #numeroEnv="ngModel" maxlength="5"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                            <div [hidden]="numeroEnv.disabled || numeroEnv.valid || (numeroEnv.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Número inválido !</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label class="center-block">
                                            Complemento
                                        </label>
                                        <input type="text" class="form-control" style="text-transform: uppercase"
                                            name="complementoEnt" value=""
                                            [(ngModel)]="subFrota.enderecos[1].complemento"
                                            style="text-transform: uppercase" maxlength="20"
                                            [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="center-block">
                                            Bairro
                                        </label>
                                        <input type="text" class="form-control" style="text-transform: uppercase"
                                            name="bairroEnt" value="" [(ngModel)]="subFrota.enderecos[1].bairro"
                                            style="text-transform: uppercase" maxlength="30"
                                            [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label
                                            [ngClass]="!isUpdate || subFrota.flagCentroCusto === 'S' ? 'control-label' : 'center-block'">
                                            UF
                                        </label>
                                        <div class="input-group">
                                            <mat-select name="ufEnv" class="form-control dropdown-filtro"
                                                [(ngModel)]="subFrota.enderecos[1].estado"
                                                (ngModelChange)="onChangeUF($event, 'ENV', subFrota.enderecos[1])"
                                                [required]="!isUpdate || subFrota.flagCentroCusto === 'S'"
                                                #ufEnv="ngModel"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                                <mat-option value="">Selecione</mat-option>
                                                <mat-option *ngFor="let uf of ufs" [value]="uf.sigla">{{uf.sigla}}
                                                </mat-option>
                                            </mat-select>
                                            <div [hidden]="ufEnv.disabled || ufEnv.valid || (ufEnv.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Selecione uma UF !</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label
                                            [ngClass]="!isUpdate || subFrota.flagCentroCusto === 'S' ? 'control-label' : 'center-block'">
                                            Cidade
                                        </label>
                                        <div class="input-group">
                                            <mat-select name="cidadeent" class="form-control dropdown-filtro"
                                                [(ngModel)]="subFrota.enderecos[1].cidade"
                                                [required]="!isUpdate || subFrota.flagCentroCusto === 'S'"
                                                #cidadeEnv="ngModel"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                                <mat-option value="">Selecione</mat-option>
                                                <mat-option *ngFor="let cidade of cidadesEnv" [value]="cidade.cidade">
                                                    {{cidade.cidade}}
                                                </mat-option>
                                            </mat-select>
                                            <div [hidden]="cidadeEnv.disabled || cidadeEnv.valid || (cidadeEnv.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Selecione uma Cidade !</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="subFrota.flagCentroCusto === 'S' || isUpdate" class="panel panel-info">
                            <div class="panel-heading">
                                <h3 class="panel-title">Endereço de Faturamento da Sub-Frota</h3>
                            </div>
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-md-3 form-group" style="display: inline-block;">
                                        <button id="salvar" type="button" class="btn btn-primary"
                                            (click)="copiarEndereco()"
                                            [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                            <i class="fa fa-copy"></i>Copiar Endereço de Envio
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3 form-group">
                                        <label
                                            [ngClass]="!isUpdate || subFrota.flagCentroCusto === 'S' ? 'control-label' : 'center-block'">
                                            CEP
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="cepfat" value=""
                                                [textMask]="{mask: cepmask}" pattern="[0-9]{5}-?[0-9]{3}"
                                                [(ngModel)]="subFrota.enderecos[0].cep"
                                                (ngModelChange)="onChangeCep($event, subFrota.enderecos[0],'FAT')"
                                                [required]="!isUpdate || subFrota.flagCentroCusto === 'S'"
                                                #cepFat="ngModel"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                            <div [hidden]="cepFat.disabled || cepFat.valid || (cepFat.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>CEP inválido !</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label
                                            [ngClass]="!isUpdate || subFrota.flagCentroCusto === 'S' ? 'control-label' : 'center-block'">
                                            Logradouro
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" style="text-transform: uppercase"
                                                name="logradouroFat" value=""
                                                [(ngModel)]="subFrota.enderecos[0].endereco"
                                                style="text-transform: uppercase" maxlength="40"
                                                [required]="!isUpdate || subFrota.flagCentroCusto === 'S'"
                                                #logradouroFat="ngModel"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                            <div [hidden]="logradouroFat.disabled || logradouroFat.valid || (logradouroFat.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Preencha o Logradouro !</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label class="center-block">
                                            Número
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="numeroFat" value=""
                                                [(ngModel)]="subFrota.enderecos[0].numero" pattern="^[0-9]\d*$"
                                                #numeroFat="ngModel" maxlength="5"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                            <div [hidden]="numeroFat.disabled || numeroFat.valid || (numeroFat.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Número inválido !</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label class="center-block">
                                            Complemento
                                        </label>
                                        <input type="text" class="form-control" style="text-transform: uppercase"
                                            name="complementoFat" value=""
                                            [(ngModel)]="subFrota.enderecos[0].complemento"
                                            style="text-transform: uppercase" maxlength="20"
                                            [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="center-block">
                                            Bairro
                                        </label>
                                        <input type="text" class="form-control" style="text-transform: uppercase"
                                            name="bairroFat" value="" [(ngModel)]="subFrota.enderecos[0].bairro"
                                            style="text-transform: uppercase"
                                            [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label
                                            [ngClass]="!isUpdate || subFrota.flagCentroCusto === 'S' ? 'control-label' : 'center-block'">
                                            UF
                                        </label>
                                        <div class="input-group">
                                            <mat-select name="ufFat" class="form-control dropdown-filtro"
                                                [(ngModel)]="subFrota.enderecos[0].estado"
                                                (ngModelChange)="onChangeUF($event, 'FAT', subFrota.enderecos[0])"
                                                [required]="!isUpdate || subFrota.flagCentroCusto === 'S'"
                                                #ufFat="ngModel"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                                <mat-option value="">Selecione</mat-option>
                                                <mat-option *ngFor="let uf of ufs" [value]="uf.sigla">{{uf.sigla}}
                                                </mat-option>
                                            </mat-select>
                                            <div [hidden]="ufFat.disabled || ufFat.valid || (ufFat.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Selecione uma UF !</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label
                                            [ngClass]="!isUpdate || subFrota.flagCentroCusto === 'S' ? 'control-label' : 'center-block'">
                                            Cidade
                                        </label>
                                        <div class="input-group">
                                            <mat-select name="cidadefat" class="form-control dropdown-filtro"
                                                [(ngModel)]="subFrota.enderecos[0].cidade"
                                                [required]="!isUpdate || subFrota.flagCentroCusto === 'S'"
                                                #cidadeFat="ngModel"
                                                [disabled]="isUpdate && subFrota.flagCentroCusto === 'N'">
                                                <mat-option value="">Selecione</mat-option>
                                                <mat-option *ngFor="let cidade of cidadesFat" [value]="cidade.cidade">
                                                    {{cidade.cidade}}
                                                </mat-option>
                                            </mat-select>
                                            <div [hidden]="cidadeFat.disabled || cidadeFat.valid || (cidadeFat.pristine && !f.submitted)"
                                                style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                                <span>Selecione uma Cidade !</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="subFrota.indPermiteConfiguracaoContingencia === 1" class="panel panel-info">
                            <div class="panel-heading">
                                <h3 class="panel-title">Configuração da Política de Contingência</h3>
                            </div>
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-md-6 form-group" style="display: inline-block;">
                                        <label class='center-block'>
                                            Aceita Contingência
                                        </label>
                                        <mat-select name="aceitaContingencia" class="form-control dropdown-filtro"
                                            [(ngModel)]="subFrota.codigoContingencia">
                                            <mat-option value="1">Sim</mat-option>
                                            <mat-option value="2">Não</mat-option>
                                            <mat-option value="3"
                                                title="Assume a Configuração da Contingência da Frota">
                                                Padrão da
                                                Frota</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="center-block">
                                            Limite de Contingência por Veículo (R$)
                                        </label>
                                        <input type="text" class="form-control" name="limiteContingencia" value=""
                                            currencyMask [(ngModel)]="subFrota.valorLimiteContingencia"
                                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                                        <span style="color:red">Válido somente para Cartão Frota Especial.</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 form-group" style="display: inline-block;">
                                        <label class='center-block'>
                                            Tipo de Contingência
                                        </label>
                                        <mat-select name="aceitaContingencia" class="form-control dropdown-filtro"
                                            [(ngModel)]="subFrota.codigoTipoContingencia">
                                            <mat-option value="1"
                                                title="Os Veículos de sua Subfrota estarão habilitados a utilizar a Contingência até atingir o Valor de Limite no Intervalo escolhido.">
                                                Automática</mat-option>
                                            <mat-option value="2"
                                                title="Os Veículos de sua SubFrota estarão habilitados a realizar apenas uma única transação ou abastecimento de contingência.Deverá ser habilitada a opção Manual novamente a cada novo abastecimento de contigência.">
                                                Manual</mat-option>

                                        </mat-select>
                                    </div>
                                    <div class="col-md-6 form-group" style="display: inline-block;">
                                        <label class='center-block'>
                                            Intervalo de Operações da Contingência
                                        </label>
                                        <mat-select name="intervaloContingencia" class="form-control dropdown-filtro"
                                            [(ngModel)]="subFrota.codigoIntervaloContingencia">
                                            <mat-option value="1">Diário</mat-option>
                                            <mat-option value="2">Semanal</mat-option>
                                            <mat-option value="3">Quinzenal</mat-option>
                                            <mat-option value="4">Mensal</mat-option>
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- {{ subFrota | json }} -->
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h3 class="panel-title">Bloqueio de Novos Postos</h3>
                            </div>
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class='center-block'>
                                            Bloquear Novos Postos para esta Sub-Frota
                                        </label>
                                        <mat-radio-group value="" aria-label="Selectione uma opção"
                                            name="flagBloqueioPostoNovo"
                                            [(ngModel)]="subFrota.flagBloqueioPostoNovo"
                                            [disabled]="subFrota.flagMostrarBloqueioPostoNovo === '0' ">
                                            <mat-radio-button value="1" class="radio-filtro">SIM</mat-radio-button>
                                            <mat-radio-button value="0" class="radio-filtro">NÃO</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-offset-10 col-md-4">
                        <a routerLink="../" class="btn btn-default"><i class="fa fa-arrow-left"></i> Voltar</a>
                        <button *ngIf="subFrota.codigoFrota" id="salvar" type="submit"
                            class="btn btn-primary btn-submit"><i class="fa fa-save"></i>Salvar alterações</button>
                    </div>
                </div>
            </form>
        </aside>
    </div>
</div>
